export function isValueMetric(value) {
    const unit = value.match(/[a-z]+$/i)?.[0]?.toLowerCase();
    return ["um", "mm", "cm", "m"].includes(unit ?? "");
}
//# sourceMappingURL=isValueMetric.js.map